import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import Form from "react-bootstrap/Form";
import { Row, Col } from 'react-bootstrap';
import { apiFetchJson } from '../api';


const DBInit = () => {

    const [statusDLT, setStatusDLT] = useState({status:'-', message: ''});
    const [statusDLO, setStatusDLO] = useState({status:'-', message: ''});
    const [statusUL, setStatusUL] = useState({status:'-', message: ''});
    const [statusRPH, setStatusRPH] = useState({status:'-', message: ''});
    const [data, setData] = useState({
        code: "",
        email: "",
        isSubmitting: false,
    });


    const handleInputChange = event => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        });
    };

    // function clickTrainessInit() {
    //     fetch('/api/db_init/trainee').then(res => res.json()).then(data => {
    //         setStatusT({status: data.status, message: data.message});
    //     });
    // };
    // function clickSupervisorsInit() {
    //     fetch('/api/db_init/supervisor').then(res => res.json()).then(data => {
    //         setStatusS({status: data.status, message: data.message});
    //     });
    // };
    // function clickAdminInit() {
    //     fetch('/api/db_init/admin').then(res => res.json()).then(data => {
    //         setStatusA({status: data.status, message: data.message});
    //     });
    // };
    // function clickDummyData() {
    //     fetch('/api/build_dummy_db_entries').then(res => res.json()).then(data => {
    //         setStatusD({status: data.status, message: data.message});
    //     });
    // };
    function clickDownloadDB() {
        const x = new Date();
        const dateStr = x.toDateString()
        apiFetchJson('/api/downloadDB/full').then(data => {
            var downloadAnchorNode = document.createElement('a');
            var downloadDBData = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data.data,undefined,2));
            downloadAnchorNode.setAttribute("href", downloadDBData);
            downloadAnchorNode.setAttribute("download", "database-cfiDB-"+dateStr+".json");
            document.body.appendChild(downloadAnchorNode); // required for firefox
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
            setStatusDLT({status: data.status, message: data.message});
        });
    };
    function clickDownloadDBSimOverview() {
        const x = new Date();
        const dateStr = x.toDateString()
        apiFetchJson('/api/downloadDBSimIDs').then(data => {
            var downloadAnchorNode = document.createElement('a');
            var downloadDBData = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data.data,undefined,2));
            downloadAnchorNode.setAttribute("href", downloadDBData);
            downloadAnchorNode.setAttribute("download", "database-cfi-simOVERVIEW-"+dateStr+".json");
            document.body.appendChild(downloadAnchorNode); // required for firefox
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
            setStatusDLO({status: data.status, message: data.message});
        });
    };

    const loadResultsMassive = () => {
        let input = document.getElementById('Uploadmassive');
        const body = new FormData();
        body.append('file', input.files[0]);

        apiFetchJson('/api/uploadMassive', {
            method: 'POST',
            body: body,
        })
            .then(data => {
                console.log('Return from zip submit', data);
                setStatusUL({status: data.status, message: data.message});
            })
            .catch(error => {
                console.log(error);
                setStatusUL({status: 'FAIL', message: 'FAIL- Please try again later or contact support'});
            })

    };

    const passwordResetHelper = () => {

        setStatusRPH({status: 'WORKING', message: ''});
        const body = new FormData();
        body.append('code', document.getElementById('rpwhCode_id').value);
        body.append('email', document.getElementById('rpwhEmail_id').value);
        apiFetchJson('/api/resetPasswordHelper', {
            method: 'POST',
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                code: data.code,
                email: data.email,
            })
        })
            .then(data => {
                console.log('Return from password reset', data);
                setStatusRPH({status: data.status, message: data.message});
            })
            .catch(error => {
                console.log(error);
                setStatusRPH({status: 'FAIL', message: 'FAIL- Please try again later or contact support'});
            })

    };




    return (
        <Container fluid>
            <Row>
                <h1>Admin use only: Databases download</h1>
            </Row>

            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Action</th>
                        <th>Status</th>
                        <th>Message</th>
                    </tr>
                </thead>
                <tbody>
                {/* <tr key="InfoR1">
                    <td><Button className="m-3" onClick={clickTrainessInit} >Initialise cfi-trainees database</Button></td>
                    <td>{statusT.status}</td>
                    <td>{statusT.message}</td>
                </tr>
                <tr key="InfoR2">
                    <td><Button className="m-3" onClick={clickSupervisorsInit} >Initialise cfi-supervisors database</Button></td>
                    <td>{statusS.status}</td>
                    <td>{statusS.message}</td>
                </tr>
                <tr key="InfoR3">
                    <td><Button className="m-3" onClick={clickAdminInit} >Initialise cfi-admin database</Button></td>
                    <td>{statusA.status}</td>
                    <td>{statusA.message}</td>
                </tr>
                <tr key="InfoR4">
                    <td><Button className="m-3" onClick={clickDummyData} >Add dummy data</Button></td>
                    <td>{statusD.status}</td>
                    <td>{statusD.message}</td>
                </tr> */}
                <tr key="DLFullR5">
                    <td><Button className="m-3" onClick={clickDownloadDB} >Download database </Button></td>
                    <td>{statusDLT.status}</td>
                    <td>{statusDLT.message}</td>
                </tr>
                <tr key="DLOR5">
                    <td><Button className="m-3" onClick={clickDownloadDBSimOverview} >Download simulation overview </Button></td>
                    <td>{statusDLO.status}</td>
                    <td>{statusDLO.message}</td>
                </tr>
                
                <tr key="UpLoadR0">
                    <Row key='uploadMassive'>
                        <Col>
                            <Form.Control type="file" key='uploadMassivef' id="Uploadmassive" name="upload"/>
                        </Col>
                        <Col>
                            <Button key='uploadMassiveB' size='sm' className="ml-1" onClick={() => loadResultsMassive()}>Load MASSIVE (ZIP file)</Button> 
                        </Col>
                    </Row>
                    <td>{statusUL.status}</td>
                    <td>{statusUL.message}</td>
                </tr>

                <tr key="ResetPHelperRow">
                    <Row key='resetPHelper'>
                        <Col>
                            <Form.Control type="text" key='rphCode' id="rpwhCode_id" name="code" 
                            onChange={handleInputChange}/>
                        </Col>
                        <Col>
                            <Form.Control type="email" key='rphEmail' id="rpwhEmail_id" name="email" 
                            onChange={handleInputChange}/>
                        </Col>
                        <Col>
                            <Button key='ResetPW' size='sm' className="ml-1" onClick={() => passwordResetHelper()}>Reset password</Button> 
                        </Col>
                    </Row>
                    <td>{statusRPH.status}</td>
                    <td>{statusRPH.message}</td>
                </tr>

                </tbody>

            </Table>


        </Container>
    );
}

export default DBInit;
